import React from "react";

// styles
import { MetaStyled } from "./styles";

// components
import CheckMark from "./CheckMark";
import ReadyForDownload from "./ReadyForDownload";
import License from "./License";
import EditorialUseOnly from "./EditorialUseOnly";

const Meta = () => {
    return (
        <MetaStyled>
            <CheckMark />
            <div>
                <ReadyForDownload />
                <License />
                <EditorialUseOnly />
            </div>
        </MetaStyled>
    );
};

export default Meta;
